import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

/**
  return twMerge(clsx(...inputs))
 * Uses clsx for conditional class combination and twMerge to properly
 * handle Tailwind CSS class conflicts.
 *
 * @param inputs - Any number of class values (strings, objects, arrays, etc.)
 * @returns A merged className string
 * 
 * @example
 * ```tsx
 * <div className={cn(
 *   'base-class',
 *   isActive && 'active-class',
 *   { 'conditional-class': condition }
 * )}>
 *   Content
 * </div>
 * ```
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
